import { useMutation, useQueryClient } from 'react-query';
import * as userResource from 'resources/user/hooks';
import { finishTransaction } from 'resources/deal/workflows';


export default function useTransactionFinish() {
  const queryClient = useQueryClient();
  const { data: user } = userResource.useCurrentUser();

  return useMutation(({ deal, status }) => finishTransaction(deal, status, user.id), {
    onSuccess: async (response) => {
      if (!response || response.isBadRequest) {
        return null;
      }

      response.client_ids.forEach((clientId) => {
        queryClient.invalidateQueries(['deal.getByClientId', clientId]);
        queryClient.invalidateQueries(['users.userById', clientId]);
      });

      queryClient.invalidateQueries('tasks.recentlyCompletedTasks'); // Home and Tasks pages
      queryClient.invalidateQueries('tasks.openTasks'); // Home and Tasks pages
      queryClient.invalidateQueries('deal.getByUserId'); // Transactions list
      queryClient.invalidateQueries('users.getRealtorClients'); // Clients list
      queryClient.invalidateQueries('deal.getByCompanyId');

      const dealId = response.id;

      if (dealId) {
        queryClient.invalidateQueries(['milestones.milestonesByDealId', dealId]); // Transaction page
        queryClient.invalidateQueries(['audits.auditsByDealId', dealId]); // Transaction page

        queryClient.invalidateQueries(['deal.getById', dealId]); // Transaction edit page
        queryClient.invalidateQueries(['documents.getByDealId', dealId]);

        queryClient.invalidateQueries(['users.getTransactionParties', dealId]); // Transaction parties
        queryClient.invalidateQueries(['deal-event.getByDealId', dealId]); // Transaction History tab
      }

      return response;
    },
  });
}
